import { memo, useCallback, useEffect, useState } from 'react';
import { Typography, Input, Tooltip, message } from 'antd';
import { debounce } from 'lodash';
import { useLinkVerifiedForGuidelineForShoot } from '../../hooks/useShootMergeGuideline';
import { CheckCircleFilled, CloseCircleFilled, LoadingOutlined, StopOutlined } from '@ant-design/icons';
import { validate } from 'uuid';

const NameFilter = ({ searchName, itemUpdater, index, setValItems, items }) => {
    const [searchText, setSearchText] = useState('');
    const { data, isFetched, isFetching, isError } = useLinkVerifiedForGuidelineForShoot(searchText);

    const isValid = !!searchText && !isError && data?.data?.isActive === true;

    useEffect(() => {
        setValItems(prev => {
            if (prev[index] === isValid) return prev;
            const next = [...prev];
            next[index] = isValid;
            return next;
        });
    }, [isValid, index]);

    const updateFilter = useCallback(
        debounce(() => {
            itemUpdater(searchText);
        }, 500),
        [searchText]
    );

    useEffect(() => {
        setSearchText(searchName);
    }, [searchName]);

    const handleNameChange = e => {
        if (items?.indexOf(e) > -1) {
            message.info('Duplicate links are not allowed!');
            setSearchText('');
        } else {
            setSearchText(e);
        }
    };

    useEffect(() => {
        if (searchName !== searchText) {
            updateFilter();
        }

        return () => updateFilter.cancel();
    }, [updateFilter, searchText]);

    return (
        <div className="" style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
            <Input
                value={searchText}
                onChange={e => {
                    handleNameChange(e.target.value);
                }}
                className="name-filter"
                placeholder=""
                style={{ marginRight: '10px', maxHeight: '150px' }}
                suffix={
                    (searchText && !!isFetching && <LoadingOutlined />) ||
                    (searchText && !!isError && (
                        <Tooltip title="Invalid">
                            <StopOutlined />
                        </Tooltip>
                    )) ||
                    (searchText &&
                        !!isFetched &&
                        (data?.data?.isActive === true ? (
                            <Tooltip title="Valid">
                                <CheckCircleFilled style={{ color: 'green' }} />
                            </Tooltip>
                        ) : (
                            <Tooltip title="Invalid">
                                <CloseCircleFilled style={{ color: 'red' }} />
                            </Tooltip>
                        )))
                }
            />
            <div className="" style={{ display: 'flex', gap: 4 }}>
                <span style={{ fontSize: 12 }}>{data?.data?.name || ''}</span>
            </div>
        </div>
    );
};

export default memo(NameFilter);
